/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  DatePicker,
  Typography,
  Card,
  Alert,
  notification,
} from 'antd';
import { CheckCircleOutlined, CheckCircleTwoTone, CloseCircleOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { getEstadosGlobales } from 'api/catalogos/index';
/*
import {
  getDiasFestivosDelAñoPag,
  getDiasFestivosDelAño,
  postDiaFestivoDelAño,
  deleteDiaFestivoDelAño,
  patchDiaFestivoDelAño,
  getDiaFestivoDelAño,
  autorizarDiaFestivoDelAño,
} from 'api/configuraciones/clock/DiasFestivos/FestivosDelAño'; */
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
} from 'utils/constants';
import moment from 'moment';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getPeriodoDeNomina, getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import { render } from '@testing-library/react';
import { CRUDIncidenciaClock } from 'api/configuraciones/clock/IncidenciasReloj/IncidenciaValidacion';
import { obtenerRegistrosDe } from 'utils/URIsSac';
import ModalErroresControls from 'components/ModalErroresControls';

const IncidenciaAutorizarReloj = (
  {
    permission, parent_data,
    fetchData, errorsVisibleEffect,
    errorsEffect,
  },
) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [disableFields, setDisableFields] = useState(false);
  const [periodoNominaDetalle, setPeriodoNominaDetalle] = useState([]);
  const [periodo, setPeriodo] = useState(null);
  const [estadosGlobales, setEstadosGlobales] = useState([]);

  const [triggerRefresh, setTriggerRefresh] = useState(0);
  const [tiempoEvaluacion, setTiempoEvaluacion] = useState('');
  const [loadingErrores, setLoadingErrores] = useState(false);
  const [pollingPackage, setPollingPackage] = useState({
    isPolling: false,
    isFinal: null,
  });
  const pollingRef = useRef(null);
  const [errores, setErrores] = errorsEffect;
  const [pageActual, setPageActual] = useState(1);
  const { Text } = Typography;
  const [visibleErrores, setVisibleErrores] = errorsVisibleEffect;
  // const onErrors = () => {
  //   setVisibleErrores(true);
  // };
  const consultarErrores = async () => {
    /// Consultar errores asociados al registro
    const response = [];
    // const erroresResp = await obtenerRegistrosDe(URIEvaluacionErrores, {
    //   pageActual,
    //   evaluacion_cierre: recordFather.id,
    // });
    // if (erroresResp?.results?.length) {
    //   response = erroresResp; // Mostrar alerta e historial
    // }
    return response;
  };
  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoadingErrores(true);
      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await consultarErrores();

      const { results } = _data;

      setPageActual(cleanPage);
      setErrores({ ..._data, results: [...results] });
      setLoadingErrores(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    if (triggerRefresh > 0) {
      fetchData();
    }
  }, [triggerRefresh]);

  useEffect(() => {
    const stopPolling = () => {
      // limpia el intervalo (deja de hacer polling)
      clearInterval(pollingRef.current);
      // resetea la ref para indicar que no hay intervalo activo
      pollingRef.current = null;
      // actualiza estados para detener el polling
      setPollingPackage({
        isPolling: false,
        isFinal: null,
      }); // <-- ACTIVAMOS EL POLLING
    };
    // si está activado el polling y hay una nómina en proceso (id definida)
    if (pollingPackage.isPolling) {
      // guarda en la ref el id del setInterval para poder limpiarlo después
      setLoading(true);
      pollingRef.current = setInterval(async () => {
        try {
          // obtiene la lista de cálculos/nóminas desde el backend
          const evaluacionActual = [];
          // await clienteEvaluacion.obtenerUnRegistro(recordFather.id);
          if (!evaluacionActual) {
            stopPolling();
            setLoading(false);
          }
          //  Si hay errores registrados en el backend
          const erroresResp = await consultarErrores();

          if (erroresResp?.length) {
            stopPolling();
            setErrores(erroresResp);
            notification.error({
              message: 'Errores en la Evaluación',
              description: 'Se encontraron errores durante la evaluación. Revisa el historial para más detalles.',
              placement: 'topRight',
            });
            setLoading(false);
          }
          // si la nómina ya tiene evaluacion_terminada significa que terminó
          if (
            // pollingPackage.isFinal
            //   ? evaluacionActual?.fecha_final_evaluacion_final
            //   : evaluacionActual?.fecha_final_evaluacionollingPackage.isFinal
            evaluacionActual?.fecha_final_evaluacion
          ) {
            stopPolling();
            // muestra una notificación de éxito al usuario
            // const _tiempo_de_evaluacion = pollingPackage.isFinal
            //   ? evaluacionActual?.tiempo_de_evaluacion_final
            //   : evaluacionActual?.tiempo_de_evaluacion;
            const _tiempo_de_evaluacion = evaluacionActual?.tiempo_de_evaluacion;
            setTiempoEvaluacion(_tiempo_de_evaluacion);
            notification.success({
              message: 'Evaluación completada',
              description: `La evaluación tomo ${_tiempo_de_evaluacion}.`,
              placement: 'topRight',
              duration: 0, // duración 0 => la notificación permanece hasta que el usuario la cierre
            });
            setTriggerRefresh((prev) => prev + 1);
          }
        } catch (error) {
          stopPolling();
          setLoading(false);
        }
      }, 10000); // intervalo de 10 segundos entre cada comprobación
    }

    // cleanup del useEffect: se ejecuta cuando se desmonta el componente o cambian deps
    return () => {
      // si hay un intervalo activo, lo limpia
      // para evitar fugas y ejecuciones en componentes desmontados
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
    // dependencias: el efecto se vuelve a ejecutar cuando cambian isPolling o nominaEnProcesoId
  }, [pollingPackage.isPolling]);

  // useEffect(() => {
  //   const fetchAll = async () => {
  //     if (!periodo) { return; }
  //     let _periodoDescuentoDetalle = await getPeriodosDeNominasDetalles(
  //       { periodo_de_nomina: periodo.periodoId },
  //     );
  //     _periodoDescuentoDetalle = _periodoDescuentoDetalle.slice(
  //       _periodoDescuentoDetalle.findIndex((p) => p.numero_de_nomina === periodo.periodoDetalle),
  //     );
  //     setPeriodoNominaDetalle(_periodoDescuentoDetalle);
  //   };
  //   fetchAll();
  //   // eslint-disable-next-line
  // }, [periodo]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
      ] = await Promise.all([
        getEstadosGlobales(),
      ]);
      if (mounted) {
        setEstadosGlobales(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    // setDisableFields(false);
    setSelectedRowKeys([]);
    // setSelectedData({});
  };

  const handleOnRowClick = async (record) => {
    /** es para cuando era solo un registro */
    // setPeriodo({
    //   periodoId: record.periodo,
    //   periodoDetalle: record.periodo_detalle,
    // });
    // Defensa extra: aunque `parent_data` ya solo debería traer registros en
    // ESTATUS_ACTIVO (ver `fetchDataAutorizar` en Incidencias.jsx), se bloquea
    // aquí también la selección de un registro que ya no esté Activo, para no
    // permitir volver a autorizar (o cancelar) algo ya procesado.
    if (record.estado_global !== ESTATUS_ACTIVO) {
      return;
    }
    if (selectedRowKeys.includes(record.id)) {
      setSelectedRowKeys(selectedRowKeys.filter((id) => id !== record.id));
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
    }
  };

  const handleSelectAll = (selected, selectedRows, changeRows) => {
    if (selected) {
      // Si el usuario marca el check de "Todos":
      // Mapeamos DIRECTAMENTE sobre 'empleadosFiltered' para obtener todos los IDs,
      // ignorando la paginación actual. Se excluyen los que ya no estén Activos.
      const allIds = parent_data
        .filter((row) => row.estado_global === ESTATUS_ACTIVO)
        .map((row) => row.id);
      setSelectedRowKeys(allIds);
    } else {
      // Si el usuario desmarca el check, limpiamos la selección
      setSelectedRowKeys([]);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onSelectAll: handleSelectAll,
    type: 'checkbox',
    getCheckboxProps: (record) => ({
      disabled: record.estado_global !== ESTATUS_ACTIVO,
    }),
  };

  const ModalCancelar = () => {
    const onConfirmCancelar = async () => {
      try {
        setLoading(true);
        // const [key] = selectedRowKeys;
        const keys = selectedRowKeys;
        if (!keys) {
          setLoading(false);
          onCancel();
          onSuccess({}, 'No se puede autorizar registros ya cancelados');
          return;
        }
        const ids = keys.map((id) => ({ id }));
        const saved = await CRUDIncidenciaClock.reemplazarRegistro(
          ESTATUS_CANCELADO,
          ids,
          '/relojchecador/agregar-guardar-incidencia/',
        );
        if (saved) {
          await fetchData();
          onCancel();
        }
        setLoading(false);
      } catch (err) {
        onError(err, setLoading);
      }
    };
    return (
      <ModalConfirmation
        onFinish={onConfirmCancelar}
        Confirm
        onCancel={() => { setVisibleCancelar(false); }}
        open={visibleCancelar}
        contentTitle="Cancelar"
        loading={loading}
      />
    );
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      // const [key] = selectedRowKeys;
      const keys = selectedRowKeys;
      if (!keys) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una incidencia ya autorizado');
        return;
      }
      const ids = keys.map((id) => ({ id }));
      const saved = await CRUDIncidenciaClock.reemplazarRegistro(
        null,
        ids,
        '/relojchecador/agregar-guardar-incidencia/',
      );
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado_id',
      key: 'empleado_id',
      width: 150,
    },
    {
      titleText: 'Nombre del Empleado',
      dataIndex: 'numero_y_nombre_completo_empelado',
      key: 'numero_y_nombre_completo_empelado',
      width: 200,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 150,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 190,
    },
    {
      titleText: 'Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Incidencia',
      dataIndex: 'tipo_de_evaluacion_de_asistencia_nombre',
      key: 'tipo_de_evaluacion_de_asistencia_nombre',
      width: 150,
    },
    {
      titleText: 'No. de Incidencias',
      dataIndex: 'numero_incidencias',
      key: 'numero_incidencias',
      width: 180,
    },
    {
      titleText: 'Minutos de Incidencia',
      dataIndex: 'minutos_incidencia',
      key: 'minutos_incidencia',
      width: 200,
    },
    {
      titleText: 'Cantidad de Descuento',
      dataIndex: 'cantidad_descuento',
      key: 'cantidad_descuento',
      width: 200,
    },
    {
      titleText: 'Unidad de Descuento',
      dataIndex: 'unidad_descuento_descripcion',
      key: 'unidad_descuento_descripcion',
      width: 210,
    },
    // {
    //   titleText: 'Fecha Inicial',
    //   dataIndex: 'fecha_inicial',
    //   key: 'fecha_inicial',
    //   width: 200,
    // },
    // {
    //   titleText: 'Fecha Final',
    //   dataIndex: 'fecha_final',
    //   key: 'fecha_final',
    //   width: 200,
    // },
    {
      titleText: 'Estatus',
      dataIndex: 'estado_global',
      key: 'estado_global',
      width: 200,
      render: (val) => estadosGlobales?.find((e) => e.id === val)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {/* <Col xs={24} sm={8} style={{ marginTop: '20px' }}>
          <Form.Item
            name="periodo_de_descuento"
            label="Periodo de Descuento"
            hasFeedback
          >
            <Select
              keyProp="id"
              labelProp="numero_de_nomina"
              // disabled={selectedRowKeys.length}
              // eslint-disable-next-line max-len
              dataSource={periodoNominaDetalle}
              render={
              (value) => `
              ${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`
              }
            />
          </Form.Item>
        </Col> */}
        {
          errores?.results?.length ? (
            <Alert
              description={(
                <code>
                  <Text>
                    Ha ocurrido un error
                  </Text>
                  <br />
                  Favor de consultar el
                  <Text
                    style={{
                      color: '#CF9660',
                      paddingLeft: '3px',
                      paddingRight: '3px',
                    }}
                  >
                    Historial de Errores
                  </Text>
                  para obtener mas información
                </code>
              )}
              type="warning"
              showIcon
              closable
              style={{ textAlign: 'center', alignItems: 'center' }}
            />
          ) : null
        }
        <div style={{ position: 'relative', paddingBottom: tiempoEvaluacion ? '30px' : '0' }}>
          <Table
            cols={columns}
            data={parent_data}
            allowExportPDF={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            permission={permission}
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'guardarincidencias', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                // disabledBySelection: true,
                // disabled: selectedData?.estado_global !== ESTATUS_ACTIVO,
                disabled: selectedRowKeys?.length < 1,
                className: 'success',
              },
              {
                permission: { model: 'guardarincidencias', action: 'cancelar' },
                onClick: () => setVisibleCancelar(true),
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
                disabledBySelection: true,
                className: 'cancel',
                // eslint-disable-next-line max-len
              },
            ]}
          />

          {/*  CONTADOR DE TIEMPO RENDERIZADO  */}
          {tiempoEvaluacion && (
            <div style={{
              display: 'flex', alignItems: 'center', position: 'absolute', bottom: -10, right: 0,
            }}
            >
              <CheckCircleTwoTone
                twoToneColor="#d88f4f"
                style={{
                  fontSize: '23px',
                  marginRight: '5px',
                }}
              />
              <Text style={{ fontSize: '0.8rem', color: '#d88f4f' }}>
                {tiempoEvaluacion}
              </Text>
            </div>
          )}
        </div>
        <Modal
          open={visibleErrores}
          title={(
            <Row justify="space-between">
              <Text style={{ fontSize: '1.25rem' }}>
                Historial de Errores
              </Text>
              <ModalErroresControls
                onCancel={() => setVisibleErrores(false)}
              />
            </Row>
          )}
          footer={null}
          closable={false}
          width="85%"
        >
          <Table
            loading={loadingErrores}
            cols={[{
              titleText: 'Descripción de Error',
              dataIndex: 'error',
              key: 'error',
              width: 200,
            }]}
            data={errores?.results || []}
            count={errores?.count || 0}
            pagination={false}
            paginationCallback={fetchPaginated}
            currentPage={pageActual}
          />
        </Modal>
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle="Autorizar Incidencias" // ${form.getFieldValue('periodo_detalle') || ''}`}
          open={visibleAutorizar}
          loading={loading}
        />
        <ModalCancelar />
      </Spin>
    </Row>
  );
};

export default IncidenciaAutorizarReloj;
